/* eslint-disable class-methods-use-this */
/* eslint-disable quote-props */
import '../../../_shared/form_builder_2/scss/index.scss';
import '../scss/modal.scss';
import LoginView from './login/index';
import PartialRegisterView from './partial-register/index';
import PasswordResetSuccessView from './password-reset-success-view/index';
import PasswordResetView from './password-reset/index';
import PasswordSendOTPView from './password-send-otp/index';
import PasswordValidateOTPView from './password-validate-otp/index';
import RegisterValidateOTPView from './register-validate-otp/index';
import RegisterView from './register/index';

export default class Modal {
    constructor(parent) {
        this.parent = parent;
        this.el = document.querySelector('.my__account__2-modal');
        this.htmlDocument = document.querySelector('html');
        this.defaultParams = {
            view: 'login',
            tab: null,
            close: true,
            guest: false,
            password: false,
        };
        this.params = { ...this.defaultParams };
        this.focusableElements = [];

        if (this.el) {
            this.back = this.el.querySelector('.modal-back');
            this.message = this.el.querySelector('.modal-message');
            this.messageContent = this.el.querySelector('.modal-message-content');
            this.close = this.el.querySelector('.modal-close');
            this.views = {
                login: new LoginView(this),
                register: new RegisterView(this),
                'register-validate-otp': new RegisterValidateOTPView(this),
                'password-send-otp': new PasswordSendOTPView(this),
                'password-validate-otp': new PasswordValidateOTPView(this),
                'password-reset': new PasswordResetView(this),
                'password-reset-success': new PasswordResetSuccessView(this),
                'partial-register': new PartialRegisterView(this),
            };
            this.bind();
        }
    }

    bind() {
        this.close.addEventListener('click', () => this.hide(true));
        this.back.addEventListener('click', () => this.currentView?.back?.());
        this.el.addEventListener('keydown', (event) => {
            this.trapFocus(event);
        });
    }

    // Exclude elements with the hide class or those that are descendants of elements with the hide class.
    updateFocusableElements() {
        this.focusableElements = Array.from(
            this.el.querySelectorAll(
                'button:not([disabled]):not(.hide):not(.hide *), [href]:not(.hide):not(.hide *), input:not([disabled]):not(.hide):not(.hide *), select:not([disabled]):not(.hide):not(.hide *), textarea:not([disabled]):not(.hide):not(.hide *), [tabindex]:not([tabindex="-1"]):not(.hide):not(.hide *)',
            ),
        );
    }

    trapFocus(event) {
        if (this.focusableElements.length === 0) return;

        const firstFocusableElement = this.focusableElements[0];
        const lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];

        if (event.key === 'Tab') {
            if (event.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstFocusableElement) {
                    event.preventDefault();
                    lastFocusableElement.focus();
                }
            } else if (document.activeElement === lastFocusableElement) {
                event.preventDefault();
                firstFocusableElement.focus();
            }
        }

        if (event.key === 'Escape') {
            this.hide(true);
        }
    }

    show(params) {
        this.el.classList.remove('hide');
        this.el.setAttribute('tabindex', '-1');
        this.el.focus();
        this.htmlDocument.classList.add('no_scroll');

        this.params = {
            ...this.params,
            ...params,
            message: params?.message,
            tab: params?.tab,
        };

        const { view } = this.params;
        const targetView = this.views[view];
        this.currentView = targetView;
        this.messageContent.textContent = this.params.message;
        if (this.params.messageType === 'success') {
            this.message.classList.add('modal-message-success');
        } else {
            this.message.classList.remove('modal-message-success');
        }

        this.toggle(this.back, targetView?.back);
        this.toggle(this.message, this.params.message);
        this.toggle(this.close, this.params.close);

        Object.values(this.views).forEach((v) => v.hide());
        targetView?.show();
        this.updateFocusableElements();
    }

    reset() {
        this.params = this.defaultParams;
    }

    hide(onClose) {
        this.el.classList.add('hide');
        this.htmlDocument.classList.remove('no_scroll');
        if (onClose) {
            this.parent.onClose();
        }
        this.reset();
    }

    toggle(el, enabled) {
        el.classList[enabled ? 'remove' : 'add']('hide');
    }
}
